import guestAxios from "@/utils/guestAxios";

export const recommendationApi = {
  getAll: ({
    search = "",
    pageNumber = 1,
    pageSize = 10,
    isAscending = false,
    sortBy = "createdAt",
  } = {}) => {
    return guestAxios.get("/api/guest-portal/recommendations", {
      params: {
        search,
        pageNumber,
        pageSize,
        isAscending,
        sortBy,
      },
      skipGuestAuthRedirect: true,
    });
  },
};
